import { accessRole } from "../../../../../../helpers/access_role"
import { config } from "../../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap"

import MKIDatatable from '../../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/anakService"

import DataTableBloc from '../Blocs/DataTableBloc'
import DetailBloc from '../../Detail/Blocs/DetailBloc'
import UpdateBloc from '../../Update/Blocs/UpdateBloc'
import apiResponse from '../../../../../../services/apiResponse'
import moment from "moment"
import Shimmer from "react-shimmer-effect";
import { Preview } from '../../../../../../helpers/ui/FileInput';
class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();
    detailBloc = new DetailBloc();
    updateBloc = new UpdateBloc();

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "")
        : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    source
    historyTable = 'historyAnakTableActive'
    defaultOrder = 'family_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
    titleCase = (s) => s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())
    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            approveUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            detailModal: false,
            detailModalData: null,
            uploadModal: false,
            uploadModalData: null,
            uploadDocumentType: null,
            uploadFile: null,
            uploadLoading: false,
            uploadSuccess: false,
            uploadFailed: false,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                },
            fileTemplate: null,
            loadingFileTemplate: true
        }
    }

    dateParse = (input) => {
        let res = "";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    openDetailModal = (record) => {
        this.setState({
            detailModal: true,
            detailModalData: record
        })
        this.detailBloc.fetchDetail({ uuid: record.family_uuid })
        console.log('detailModalData', record)
        this.updateBloc.fetchFileTemplate({ uuid: "6876f182-b207-4d04-b8e4-f3008b9b4577" })
    }

    closeDetailModal = () => {
        this.setState({
            detailModal: false,
            detailModalData: null,
            fileTemplate: null,
            loadingFileTemplate: true
        })
    }

    openUploadModal = (record) => {
        this.setState({
            uploadModal: true,
            uploadModalData: record,
            uploadDocumentType: null,
            uploadFile: null,
            fileTemplate: null,
            loadingFileTemplate: true
        })
        this.updateBloc.fetchFileTemplate({ uuid: "6876f182-b207-4d04-b8e4-f3008b9b4577" })
    }

    closeUploadModal = () => {
        this.setState({
            uploadModal: false,
            uploadModalData: null,
            uploadDocumentType: null,
            uploadFile: null,
            uploadLoading: false,
            uploadSuccess: false,
            uploadFailed: false,
            fileTemplate: null,
            loadingFileTemplate: true
        })
    }

    handleFileChange = (e) => {
        const file = e.target.files[0]
        this.setState({ uploadFile: file })
    }

    submitUploadData = async () => {
        if (!this.state.uploadFile) {
            alert('Pilih file terlebih dahulu')
            return
        }
        // if (!this.state.uploadDocumentType) {
        //     alert('Pilih jenis dokumen terlebih dahulu')
        //     return
        // }

        const formData = new FormData()
        formData.append('family_uuid', this.state.uploadModalData.family_uuid)
        formData.append('family_document_type', "file_surat_keterangan_anak")
        formData.append('file_doc[]', this.state.uploadFile)

        this.setState({ uploadLoading: true })

        try {
            // TODO: Replace with actual API endpoint
            // await uploadApi(formData)
            await this.updateBloc.fetchUpdateFile(formData);
            console.log('Uploading:', formData)

            this.setState({
                uploadLoading: false,
                uploadSuccess: true
            })

            setTimeout(() => {
                this.closeUploadModal()
                this.setTokenAPI()
            }, 1500)
        } catch (error) {
            this.setState({
                uploadLoading: false,
                uploadFailed: true
            })
            console.error('Upload error:', error)
        }
    }

    handleUploadSubmit = async () => {
        if (!this.state.uploadFile) {
            alert('Pilih file terlebih dahulu')
            return
        }
        // if (!this.state.uploadDocumentType) {
        //     alert('Pilih jenis dokumen terlebih dahulu')
        //     return
        // }
        this.submitUploadData()
    }

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            uuid: this.peg_uuid,
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            document_skk: response.document_skk,
                            documents: response.documents,
                            isLocal: response.family_place_of_birth_national == "Luar Negeri" ? 0 : 1,
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.updateBloc.updateFileChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break;
                default:
                    break;
            }
        });
        this.updateBloc.detailtemplateSuratChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        const detail = result.data.response
                        this.setState({
                            fileTemplate: detail.template_surat_file_path || null,
                            loadingFileTemplate: false
                        })
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({ loadingFileTemplate: false })
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.detailBloc.detailChannel.unsubscribe()
    }

    columns = [
        {
            key: "family_name",
            text: "Nama",
            className: "family_name",
            sortable: true,
            width: '20%'
        },
        {
            key: "family_gender_name",
            text: "Jenis Kelamin",
            className: "family_gender",
            sortable: true,
            width: '140'
        },
        {
            key: "family_date_of_birth",
            text: "Tanggal Lahir",
            className: "family_date_of_birth",
            sortable: true,
            cell: record => {
                return this.dateParse(record.family_date_of_birth);
            }
        },
        {
            key: "family_age",
            text: "Umur",
            className: "   FROM transaction.emp_family aa",
            sortable: true,
        },
        {
            key: "family_relationship_status_name",
            text: "Status Anak",
            className: "family_relationship_status_name",
            sortable: true,
        },
        {
            key: "family_status_name",
            text: "Status",
            className: "family_status_name",
            sortable: true,
            width: '100',
            cell: record => {
                var status = record.family_status
                var status_name = record.family_status_name
                return (
                    <span>
                        {parseInt(status) == 1 ?
                            <label className="badge rounded-pill bg-soft-success font-size-12" >{status_name}</label> :
                            <label className="badge rounded-pill bg-soft-warning font-size-12" >{status_name}</label>}
                    </span>
                )
            }
        },
        {
            key: "dokumen",
            text: "Surat Keterangan",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.family_id
                const status = record.family_status
                const familyAge = parseInt(record.family_age, 10)
                if (isNaN(familyAge) || familyAge < 21) {
                    return null
                }
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-doc-" + thisId}
                                onClick={() => this.openDetailModal(record)}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-file"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detaildoc" + thisId]} target={"detail-doc-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detaildoc" + thisId]: !this.state["detaildoc" + thisId]
                                    })
                                }}
                            >Detil</Tooltip>
                        </span>
                        {accessRole('update') && (status == 1 || status == 2) ?
                            <span>
                                <button
                                    className="btn btn-warning btn-sm"
                                    id={"updatesurat-" + thisId}
                                    onClick={() => this.openUploadModal(record)}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-upload"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["update" + thisId]: !this.state["update" + thisId]
                                        })
                                    }}
                                >Upload Surat Keterangan</Tooltip>
                            </span>
                            : null
                        }
                    </Fragment>
                );
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.family_id
                const status = record.family_status
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-action-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.family_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-align-left"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detailaction" + thisId]} target={"detail-action-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detailaction" + thisId]: !this.state["detailaction" + thisId]
                                    })
                                }}
                            >Detil</Tooltip>
                        </span>
                        {accessRole('update') && (status == 1 || status == 2) ?
                            <span>
                                <button
                                    className="btn btn-warning btn-sm"
                                    id={"update-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            updateUuid: record.family_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-pen"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["update" + thisId]: !this.state["update" + thisId]
                                        })
                                    }}
                                >Perbaharui</Tooltip>
                            </span>
                            : null
                        }
                        {accessRole('delete') && status == 1 ?
                            <span>
                                <button
                                    className="btn btn-danger btn-sm"
                                    id={"delete-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            inactiveUuid: record.family_uuid,
                                            confirm: true
                                        })
                                    }}
                                    style={{
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-trash-alt"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["delete" + thisId]: !this.state["delete" + thisId]
                                        })
                                    }}
                                >Nonaktifkan</Tooltip>
                            </span>
                            : null
                        }
                        {accessRole('approve') && status == 0 ?
                            <span>
                                <button
                                    className="btn btn-success btn-sm"
                                    id={"approve-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            approveUuid: record.family_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-check"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["approve" + thisId]} target={"approve-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["approve" + thisId]: !this.state["approve" + thisId]
                                        })
                                    }}
                                >Approve</Tooltip>
                            </span>
                            : null
                        }
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                <Modal isOpen={this.state.detailModal} toggle={this.closeDetailModal} size="lg">
                    <ModalHeader toggle={this.closeDetailModal}>
                        Surat Keterangan Anak
                    </ModalHeader>
                    <ModalBody>
                        {this.state.detailModalData ?
                            <Row className="g-3">
                                <Col xs={12} md={6}>
                                    <div className="border rounded p-2">
                                        <p className="mb-1"><strong>Nama</strong></p>
                                        <p className="mb-1 text-muted">{this.state.detailModalData.family_name}</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={6}>
                                    <div className="border rounded p-2">
                                        <p className="mb-1"><strong>Umur</strong></p>
                                        <p className="mb-1 text-muted">{this.state.detailModalData.family_age}</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={6}>
                                    <div className="border rounded p-2">
                                        <p className="mb-1"><strong>Jenis Kelamin</strong></p>
                                        <p className="mb-1 text-muted">{this.state.detailModalData.family_gender_name}</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={6}>
                                    <div className="border rounded p-2">
                                        <p className="mb-1"><strong>Status Anak</strong></p>
                                        <p className="mb-1 text-muted">{this.state.detailModalData.family_relationship_status_name}</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={6}>
                                    <div className="border rounded p-2">
                                        <p className="mb-1"><strong>Tanggal Lahir</strong></p>
                                        <p className="mb-1 text-muted">{this.dateParse(this.state.detailModalData.family_date_of_birth)}</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={6}>
                                    <div className="border rounded p-2">
                                        <p className="mb-1"><strong>Status</strong></p>
                                        <p className="mb-1 text-muted">{this.state.detailModalData.family_status_name}</p>
                                    </div>
                                </Col>
                            </Row>
                            : <div>Detail tidak tersedia.</div>
                        }
                        <hr />
                        <div className="mb-3">
                            <strong>Template Surat Keterangan:</strong>
                            {this.state.loadingFileTemplate ? (
                                <span className="ms-2">Loading template...</span>
                            ) : this.state.fileTemplate ? (
                                <a href={this.state.fileTemplate} target="_blank" rel="noopener noreferrer" className="btn btn-info btn-sm text-white ms-2">
                                    <i className="uil-download me-1"></i> Unduh Template
                                </a>
                            ) : (
                                <span className="text-muted ms-2">Tidak tersedia</span>
                            )}
                        </div>
                        <hr />
                        {this.state.documents?.length > 0 &&
                            <Row className="g-3">
                                {this.state.documents.map((val, i) => (
                                    <Col xs={12} md={6} key={i}>
                                        <div className="border rounded p-2 h-100">
                                            <p className="mb-1"><strong>{this.titleCase(val.family_document_type)}</strong></p>
                                            {val.document ?
                                                <Preview value={val.document} style={{ width: 'fit-content' }} />
                                                : <Shimmer><div style={{ width: 68, height: 15 }}></div></Shimmer>
                                            }
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeDetailModal}>Tutup</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.uploadModal} toggle={this.closeUploadModal} size="md">
                    <ModalHeader toggle={this.closeUploadModal}>
                        Upload Surat Keterangan Anak
                    </ModalHeader>
                    <ModalBody>
                        {this.state.uploadSuccess ?
                            <div className="alert alert-success" role="alert">
                                <i className="uil-check-circle"></i> <strong>Berhasil!</strong> File berhasil diupload.
                            </div>
                            : this.state.uploadFailed ?
                                <div className="alert alert-danger" role="alert">
                                    <i className="uil-times-circle"></i> <strong>Gagal!</strong> Terjadi kesalahan saat upload.
                                </div>
                                : this.state.uploadModalData ?
                                    <div>
                                        <p><strong>Nama Anak:</strong> {this.state.uploadModalData.family_name}</p>
                                        <div className="mb-3">
                                            <strong>Template Surat Keterangan:</strong>
                                            {this.state.loadingFileTemplate ? (
                                                <span className="ms-2 text-muted">Loading template...</span>
                                            ) : this.state.fileTemplate ? (
                                                <a href={this.state.fileTemplate} target="_blank" rel="noopener noreferrer" className="btn btn-info btn-sm text-white ms-2">
                                                    <i className="uil-download me-1"></i> Unduh Template
                                                </a>
                                            ) : (
                                                <span className="text-muted ms-2">Tidak tersedia</span>
                                            )}
                                        </div>

                                        {/* <div className="mb-3">
                                    <label className="form-label">Jenis Dokumen</label>
                                    <select
                                        name="family_document_type"
                                        className="form-control"
                                        value={this.state.uploadDocumentType || ""}
                                        onChange={(e) => {
                                            this.setState({
                                                uploadDocumentType: e.target.value || null,
                                            })
                                        }}
                                        disabled={this.state.uploadLoading}
                                    >
                                        <option value="">Pilih Jenis Dokumen</option>
                                        <option value="file_akta_kelahiran">Akta Kelahiran</option>
                                        <option value="file_surat_kematian">Surat Kematian</option>
                                        <option value="file_buku_nikah">Buku Nikah</option>
                                        <option value="file_surat_keterangan_kuliah">Surat Keterangan Kuliah</option>
                                        <option value="file_surat_keterangan_kerja">Surat Keterangan Kerja</option>
                                        <option value="file_ijazah">Ijazah</option>
                                    </select>
                                </div> */}
                                        <input type="hidden" name="family_document_type" value="file_surat_keterangan_anak" />

                                        <div className="mb-3">
                                            <label className="form-label">Pilih File Surat Keterangan</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={this.handleFileChange}
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                disabled={this.state.uploadLoading}
                                            />
                                            <small className="form-text text-muted">Format: PDF, DOC, DOCX, JPG, PNG (Max 5MB)</small>
                                        </div>
                                        {this.state.uploadFile &&
                                            <div className="alert alert-info" role="alert">
                                                <strong>File dipilih:</strong> {this.state.uploadFile.name}
                                            </div>
                                        }
                                    </div>
                                    : <div>Data tidak tersedia.</div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeUploadModal} disabled={this.state.uploadLoading}>Batal</Button>
                        <Button color="primary" onClick={this.handleUploadSubmit} disabled={this.state.uploadLoading || this.state.uploadSuccess}>
                            {this.state.uploadLoading ? <span><i className="uil-spinner-alt me-2" style={{ animation: 'spin 1s linear infinite' }}></i>Uploading...</span> : 'Upload'}
                        </Button>
                    </ModalFooter>
                </Modal>
                {this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?anak&detail&uuid=" + this.state.detailUuid} />
                    : null}
                {this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?anak&update&uuid=" + this.state.updateUuid} />
                    : null}
                {this.state.approveUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?anak&approve&uuid=" + this.state.approveUuid} />
                    : null}
            </>
        )
    }

}

export default TableActiveComponent
